import React, { Fragment, Component } from 'react';
import { NavLink } from 'redux-first-router-link';
import PropTypes from 'prop-types';
import { InView } from 'react-intersection-observer';
import { getFileName, isValid, segmentTrackEvent, isText } from '../../utils';
import { appendImgixParamsLander, setCardImage, TOP_CARD, SMALL_CARD, FEATURED_CARD } from '../../imgixUtils';
const {
  SITE_HOST,
} = process.env;

class ArticleCard extends Component {
  constructor() {
    super();
    this.state = {
      toggled: false
    }
    this.handleHover = this.handleHover.bind(this);
  }

  handleHover(shouldToggle) {
    this.setState({
      toggled: shouldToggle
    });
  }

  render() {
    const { data, isMobile, isClient, shouldDisplaySponsored, showCategory = true, isReferral, isRecirculation = false, isContentHub = false, showPubdate = false, isCarousel = false } = this.props;
    if (!isValid(data)) { return null; }
    const { toggled } = this.state;
    const {
      url=null,
      headline=null,
      dek=null,
      category=null,
      cateogory=null,
      authorName=null,
      sponsored=null,
      cardClass=null,
      categoryImage=null,
      featuredArticleBodyCopy=null,
      featuredArticleImageCreditOverride=null,
      featuredArticleImageOverride=null,
      featuredArticleTeaserOverride=null,
      featuredArticleTitleOverride=null,
      featuredArticleImageAlt=null,
      isCustomContent=null,
      publishData=null
    } = data;
    if (!isValid(categoryImage) || !isText(url)) { return null; }
    const {
      date = null,
      first = null,
      updated = null,
    } = publishData || {};
    const className = `article-card ${cardClass} col-3 ${isCarousel} ${isCarousel ? 'col-3-sm' : 'col-4-sm'}`;
    const cardImgClass = toggled ? 'card-img hover' : 'card-img';
    const imageSrc = (cardClass === FEATURED_CARD && featuredArticleImageOverride) ? featuredArticleImageOverride : setCardImage(data, isMobile);
    const imageAlt = featuredArticleImageAlt ? featuredArticleImageAlt : (data.categoryImage.imageAlt || getFileName(imageSrc));
    const imageCredit = (cardClass === FEATURED_CARD && featuredArticleImageCreditOverride) ? featuredArticleImageCreditOverride
      : (cardClass === 'big-card' && isText(data.categoryImage.universalCredit) && !isText(data.categoryImage.imageCredit)) ? data.categoryImage.universalCredit
      : (isText (data.categoryImage.imageCredit)) ? data.categoryImage.imageCredit
      : null;

    const articleHeadline = (cardClass === FEATURED_CARD && featuredArticleTitleOverride) ? featuredArticleTitleOverride : headline;
    let articleDek = (cardClass === FEATURED_CARD && featuredArticleBodyCopy) ? featuredArticleBodyCopy : featuredArticleTeaserOverride;
    const maxLength = isMobile ? 70 : 170;
    articleDek = articleDek ? (articleDek.length > maxLength ? articleDek.substr(0, maxLength) + '...' : articleDek) : null;
    const showDek = (cardClass === TOP_CARD) || (cardClass === FEATURED_CARD);
    // this should be updated to only apply to the top card...?
    const rootMargin = `0% 0% ${isMobile ? '50%' : '25%'} 0%`;
    const newUrl = `/${url}`;

    const renderDate = (rawDate) => {
      if (!rawDate) return null; 
      const parsedDate = rawDate instanceof Date ? rawDate : new Date(rawDate); 
      if (isNaN(parsedDate)) return null; 

      const month = parsedDate.getMonth() + 1; 
      const day = parsedDate.getDate();
      const year = parsedDate.getFullYear().toString().slice(-2);

      return `${month}.${day}.${year}`;
    };

    const pubDate =
      showPubdate && first
        ? new Date(first) 
        : showPubdate && date
        ? new Date(date)
        : null;

    const upDate = showPubdate && date ? new Date(date) : null;

    const renderedDate =
      showPubdate && pubDate
        ? upDate && upDate > pubDate
          ? renderDate(upDate) 
          : renderDate(pubDate) 
        : null;


    // check that image flash doesn't keep happening after css updates are applied.
    const card = (
      <div className={`card-wrapper col-3 ${isCarousel ? 'col-3-sm' : 'col-2-sm'}`}>
        <div className="card-details">
            <div className="card-author">
              {showCategory && 
                <div className="card-author-category">{category} </div>
              }
              { (sponsored === 'Sponsored') ? (
                <div className="sponsored">{showCategory ? '/ ' : ''}Sponsored</div>
              ) : ( 
                <div className="card-author-name">
                {showCategory ? '/ ' : ''}
                {authorName && authorName}
                {showPubdate ? ' / ' : ''}
                </div>
              )}
              { showPubdate && 
                <div className="card-author-date">{renderedDate}</div>
              }
            </div>
            <h3
              className="card-headline"
              dangerouslySetInnerHTML={{ __html: articleHeadline }}>
            </h3>
          {showDek &&
            <Fragment>
              <div className="divider"/>
              <h5 className="card-dek">{articleDek}</h5>
            </Fragment>
          }
        </div>
      </div>
    );

    const cardImg = 
    <InView triggerOnce={isClient} rootMargin={rootMargin}>
      {({ inView, ref }) => (
        <div ref={ref} className={`card-img-container col-3 ${isCarousel ? 'col-3-sm' : 'col-2-sm'}`}>
          {(imageSrc && inView) &&
              <Fragment>
                <img className={cardImgClass} src={imageSrc} alt={imageAlt} />
                {isText(imageCredit) && <span className="img-credit" dangerouslySetInnerHTML={ { __html: imageCredit } }></span>}
              </Fragment>
          }
        </div>
      )}
    </InView>;

    let recipeOrCustomUrl = null;
    if (category === 'recipes' || cateogory === 'recipes' || isCustomContent) {
      recipeOrCustomUrl = `${SITE_HOST}${newUrl}`;
    }

    const renderedArticleCard = 
    category === 'recipes' || isCustomContent || cateogory === 'recipes' ? (
      <a 
        className={className}
        href={recipeOrCustomUrl}
        onMouseEnter={() => this.handleHover(true)} 
        onMouseLeave={() => this.handleHover(false)}
        { ...(isContentHub && { target: "_blank" }) }
        onClick={() => { isReferral ? segmentTrackEvent('referral_eop_clicked', { action: 'click', label: newUrl }) : undefined }}>
        {cardImg}
        {card}
      </a>
    ) : (
      <NavLink 
        className={className}
        to={newUrl}
        onMouseEnter={() => this.handleHover(true)} 
        onMouseLeave={() => this.handleHover(false)}
        { ...(isContentHub && { target: "_blank" }) }
        onClick={() => { isReferral ? segmentTrackEvent('referral_eop_clicked', { action: 'click', label: newUrl }) : undefined }}>
        {cardImg}
        {card}
      </NavLink>
    );
    
    return (
      renderedArticleCard
    );
  }
};

ArticleCard.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default ArticleCard;
